export enum SignUpSteps {
  selectYourFarmbox = 0,
  deliveryInformation = 1,
  personalInformation = 2,
  paymentInformation = 3,
  preferences = 4
}

export enum InstagramMediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  CAROUSEL_ALBUM = 'CAROUSEL_ALBUM'
}

export enum TipOptions {
  RECURRENT = 'RECURRENT',
  ONE_TIME = 'ONE_TIME',
}


export enum ProductType {
  subscription = 'subscription',
  common = 'common'
}

export enum SuggestedProductsType {
  marketplace = 'marketplace',
  favorite = 'favorite',
  buyAgain = 'buyAgain'
}